import { forwardRef } from 'react';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import SkillCard from './skillCard';
import BaseBlock from './BaseBlock';

import GrowOnScroll from './animation/GrowAnimation';

function SkillList(props) {
  const skills = props.data.skills;

  const skillItemList = Object.keys(skills).map((skillName) => {
    const skill = skills[skillName];
    const skillMediaPath = skill.mediaPath;
    const skillItems = skill.item;

    return (
      <Grid item xs={12} sm={12} md={4} align="center" key={skillName}>
        <GrowOnScroll
          children={
            <SkillCard skillName={skillName} skillDescription={skillItems} skillMediaPath={skillMediaPath}>
            </SkillCard>
          }
        >
        </GrowOnScroll>
      </Grid>
    );
  })

  return (
    <Box>
      <Grid container
        spacing={{ xs: 2, sm: 3 }}
        columns={{ xs: 4, sm: 12, md: 12 }}
      >
        {skillItemList}
      </Grid>
    </Box>
  );
}

function SkillsBlock(props) {
  return (
    <BaseBlock
      blockTitle='Skills'
      blockSubtitle='Techincal Stack / Proficient Tools'
      blockContent={<SkillList data={props.data}></SkillList>}
    >
    </BaseBlock>
  );
}

const Skills = forwardRef((props, ref) => {
  return (
    <Box ref={ref}>
      <SkillsBlock data={props.data}>
      </SkillsBlock>
    </Box>
  );
});

export default Skills;